import React, { useState } from "react";

function AjouterMedia() {
  const [message, setMessage] = useState("");
  const [media, setMedia] = useState({
    type: "",
    nom: "",
    duree: "",
    url: "",
    recent: "",
    trailer: "",
    seasons: [
      {
        seasonNumber: 1,
        episodes: [""],
      },
    ],
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("media/create-media", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(media),
      });

      if (response.status === 201) {
        setMessage("Création réussie");
      } else {
        setMessage("Erreur serveur");
      }
    } catch (error) {
      setMessage("Erreur lors de la création");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMedia({ ...media, [name]: value });
  };

  const handleSeasonsChange = (e) => {
    const seasons = parseInt(e.target.value, 10);
    setMedia({
      ...media,
      seasons: Array.from({ length: seasons }, (_, seasonIndex) => ({
        seasonNumber: seasonIndex + 1,
        episodes: media.seasons[seasonIndex]?.episodes || [""],
      })),
    });
  };

  const handleEpisodeChange = (e, seasonIndex, episodeIndex) => {
    const newMedia = { ...media };
    newMedia.seasons[seasonIndex].episodes[episodeIndex] = e.target.value;
    setMedia(newMedia);
  };

  const handleAddEpisode = (seasonIndex) => {
    const newMedia = { ...media };
    newMedia.seasons[seasonIndex].episodes.push("");
    setMedia(newMedia);
  };

  const handleRemoveEpisode = (seasonIndex, episodeIndex) => {
    const newMedia = { ...media };
    newMedia.seasons[seasonIndex].episodes.splice(episodeIndex, 1);
    setMedia(newMedia);
  };

  return (
    <section>
      <div className="container_news">
        <form method="post" action="/ajout-media" onSubmit={handleSubmit}>
          <label htmlFor="type">Choisir un type de media</label>
          <select name="type" value={media.type} onChange={handleChange}>
            <option value="" disabled>
              Choose
            </option>
            <option value="film">Film</option>
            <option value="serie">Serie</option>
          </select>

          <label htmlFor="nom">Nom</label>
          <input
            type="text"
            name="nom"
            value={media.nom}
            onChange={handleChange}
          />
          <label htmlFor="duree">Durée du media</label>
          <input
            type="text"
            name="duree"
            value={media.duree}
            onChange={handleChange}
          />
          <label htmlFor="url">Image du media</label>
          <input
            type="text"
            name="url"
            value={media.url}
            onChange={handleChange}
          />

          <label htmlFor="recent">Nouveau film ?</label>
          <select name="recent" value={media.recent} onChange={handleChange}>
            <option value="" disabled>
              Choose
            </option>
            <option value="new">Oui</option>
            <option value="old">Non</option>
          </select>

          {media.type === "serie" && (
            <div>
              <label htmlFor="seasons">Nombre de saisons</label>
              <input
                type="number"
                name="seasons"
                value={media.seasons.length}
                onChange={handleSeasonsChange}
              />

              {media.seasons.map((season, seasonIndex) => (
                <div key={seasonIndex}>
                  <label htmlFor={`episode${seasonIndex + 1}`}>
                    Lien pour la saison {season.seasonNumber}
                  </label>

                  {season.episodes.map((episode, episodeIndex) => (
                    <div key={episodeIndex}>
                      <label htmlFor={`episode${seasonIndex + 1}-${episodeIndex + 1}`}>
                        Lien pour l'épisode {episodeIndex + 1}
                      </label>
                      <input
                        type="text"
                        name={`episode${seasonIndex + 1}-${episodeIndex + 1}`}
                        value={episode}
                        onChange={(e) => handleEpisodeChange(e, seasonIndex, episodeIndex)}
                      />

                      <button
                        type="button"
                        onClick={() => handleRemoveEpisode(seasonIndex, episodeIndex)}
                      >
                        Supprimer l'épisode
                      </button>
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={() => handleAddEpisode(seasonIndex)}
                  >
                    Ajouter un épisode
                  </button>
                </div>
              ))}
            </div>
          )}

          <button type="submit">Ajouter le media</button>
        </form>

        <p className="message">{message}</p>
      </div>
    </section>
  );
}

export default AjouterMedia;
